import { render, staticRenderFns } from "./HomeAnnouncementList.vue?vue&type=template&id=ff38435e&scoped=true"
import script from "./HomeAnnouncementList.vue?vue&type=script&lang=js"
export * from "./HomeAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./HomeAnnouncementList.vue?vue&type=style&index=0&id=ff38435e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff38435e",
  null
  
)

export default component.exports